import React from 'react'

import type { Poll } from '../model/Poll'

type PollQuestionProps = {
  poll: Poll
}

export const PollQuestion = ({ poll }: PollQuestionProps) => (
  <div className="question-wrapper">{poll.question}</div>
)
